import { Route, Switch } from 'react-router-dom'

import Layout from './components/features/Layout/Layout'

// Pages ---------
import AccountDetail from './components/features/Accounts/AccountDetail'
import PasswordResetPage from './components/features/Login/PasswordResetPage/PasswordResetPage'
import PayMyBillPage from './components/features/PayMyBillPage/PayMyBillPage'
import MyProfile from './components/features/ProfilePage/MyProfile'
import AccountWrapper from './components/features/Layout/AccountWrapper'
import BillsUsage from './components/features/BillsUsage/BillsUsage'
import ManageAccountsPage from './components/features/Accounts/ManageAccount/ManageAccountsPage'
import AutoPayPage from './components/features/AutoPay/AutoPayPage'
import PaymentMethods from './components/features/PaymentMethods/PaymentMethods'
import PaymentHistoryPage from './components/features/PaymentHistoryPage/PaymentHistoryPage'

// Components ---------
import Modal from './components/features/Modals/Modal'

export default function BaseRouter() {
  return (
    <>
      <Switch>
        <Route exact path="/" component={ManageAccountsPage}/>
        <Route path="auth/reset-password" component={PasswordResetPage}/>
        <Layout>
          <Route path="/account/:id">
            <AccountWrapper>
              <Route exact path="/account/:id/detail" component={AccountDetail}/>
              <Route path="/account/:id/profile" component={MyProfile}/>
              <Route path="/account/:id/pay-my-bill" component={PayMyBillPage}/>
              <Route path="/account/:id/bills-and-usage" component={BillsUsage}/>
              <Route path="/account/:id/autopay" component={AutoPayPage}/>
              <Route path="/account/:id/payment-history" component={PaymentHistoryPage}/>
              <Route path="/account/:id/payment-methods" component={PaymentMethods}/>
            </AccountWrapper>
          </Route>
        </Layout>
      </Switch>
      <Modal/>
    </>
  )
}
